import { Fragment, memo, FunctionComponent } from "react";
import COLORS from "../../theme/Colors";
import { Container } from "./styles/RadioButtonGroupStyles";
import { FieldTitle, Row } from "../../theme/Styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { FormControl, FormHelperText } from "@mui/material";
import { OptionSelectItem } from "./RadioButtonGroupConstants";

const RadioButtonGroup: FunctionComponent<propTypes> = (props) => {
  const radioValue = props.value === undefined ? "" : props.value;
  return (
    <Container>
      <Row>
        <FieldTitle>{props.title} </FieldTitle>
        <div style={{ width: "5px" }} />
        {props.required ? (
          <Fragment>
            <FieldTitle style={{ color: COLORS.red }}>*</FieldTitle>
          </Fragment>
        ) : null}
      </Row>
      <FormControl
        disabled={props.disabled}
        required={props.required}
        error={props.error}
        component="fieldset"
        variant="standard"
      >
        <FormGroup>
          <RadioGroup
            name={props.id}
            value={radioValue}
            onChange={props.onChange}
            onBlur={props.onBlur}
            row={props.row}
          >
            {props.options?.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Radio
                    sx={{
                      color: COLORS.primary,
                      "&.Mui-checked": {
                        color: COLORS.primary,
                      },
                    }}
                  />
                }
                label={option.label}
              />
            ))}
          </RadioGroup>
        </FormGroup>
          <FormHelperText sx={{ fontSize: "0.90rem" }}>
            {props.helperText}
          </FormHelperText>
      </FormControl>
    </Container>
  );
};

export interface propTypes {
  id: string;
  title?: string;
  value: string | number | undefined;
  options: OptionSelectItem[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  helperText?: string | boolean;
  row?: boolean;
}

RadioButtonGroup.defaultProps = {
  helperText: " ",
  row: false,
};

export default memo(RadioButtonGroup);
